import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { IslamicPatternCorner } from "@/components/IslamicPattern";

const PageHeader = ({ title, subtitle, crumbs = [] }) => (
  <div className="relative overflow-hidden border-b border-emerald-100 bg-gradient-to-br from-emerald-700 via-emerald-800 to-emerald-950">
    <IslamicPatternCorner className="pointer-events-none absolute -right-10 -top-10 h-56 w-56 text-emerald-400/30" />
    <IslamicPatternCorner className="pointer-events-none absolute -bottom-16 left-1/3 h-40 w-40 text-emerald-400/20" />
    <div className="relative mx-auto max-w-6xl px-6 py-12 sm:py-14">
      <nav className="mb-3 flex items-center gap-1.5 text-xs font-medium text-emerald-200/90">
        <Link to="/" className="hover:text-white transition-colors">Beranda</Link>
        {crumbs.map((c, i) => (
          <span key={i} className="flex items-center gap-1.5">
            <ChevronRight className="h-3 w-3" />
            {c.to ? <Link to={c.to} className="hover:text-white transition-colors">{c.label}</Link> : <span className="text-white">{c.label}</span>}
          </span>
        ))}
      </nav>
      <h1 className="font-heading text-3xl font-bold tracking-tight text-white sm:text-4xl">{title}</h1>
      {subtitle && <p className="mt-2 max-w-2xl text-sm text-emerald-100/90 sm:text-base">{subtitle}</p>}
    </div>
  </div>
);

export default PageHeader;
